import { render, staticRenderFns } from "./PLPCareplanBanner.vue?vue&type=template&id=4d28e824&"
import script from "./PLPCareplanBanner.vue?vue&type=script&lang=ts&"
export * from "./PLPCareplanBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesPLPCareplanUsps: require('/var/www/packages/theme/components/molecules/PLPCareplanUsps.vue').default,MoleculesPLPCareplanImageBanner: require('/var/www/packages/theme/components/molecules/PLPCareplanImageBanner.vue').default})
